import { render, staticRenderFns } from "./JcomBusinessCategoryCreate.vue?vue&type=template&id=1f871fc6"
import script from "./JcomBusinessCategoryCreate.vue?vue&type=script&lang=js"
export * from "./JcomBusinessCategoryCreate.vue?vue&type=script&lang=js"
import style0 from "./JcomBusinessCategoryCreate.vue?vue&type=style&index=0&id=1f871fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports